import React, { useEffect, useState } from 'react';

import axios from 'axios'

import { ProductSearchHelper } from "../../helpers"
import { Loading } from "../../components"

const SearchCount = ({ search, className = '' }) => {
    const [ count, setCount ] = useState(null)

    useEffect(() => {
        const fetchCount = async () => {
            const { data : count } = await axios.post(
                '/api/listings/search/count',
                ProductSearchHelper.prepareForServer(search)
            )

            setCount(count)
        }

        setCount(null)
        fetchCount()
    }, [ search ])

    if (count === null) {
        return <Loading type="small" className={className} />
    }

    return <span className={className}>{count} product{count !== 1 ? 's' : ''} found...</span>
}

export default SearchCount
